import * as firebase from 'firebase'
import moment from 'moment'

const SummaryQueries = {
  pastJobs : {
    attach: (teamId, contactId, customerId, listener) => {
      const today = moment().format('YYYY-MM-DD')
      const startKey = `${contactId}@${customerId}@`
      const endKey = `${contactId}@${customerId}@${today}`
      firebase.database()
        .ref(`customer_events/${teamId}`)
        .orderByChild('customerContactId_endDate')
        .startAt(startKey)
        .endAt(endKey)
        .on('value', listener)
    },
    detach: (teamId, contactId, customerId, listener) => {
      const today = moment().format('YYYY-MM-DD')
      const startKey = `${contactId}@${customerId}@`
      const endKey = `${contactId}@${customerId}@${today}`
      firebase.database()
        .ref(`customer_events/${teamId}`)
        .orderByChild('customerContactId_endDate')
        .startAt(startKey)
        .endAt(endKey)
        .off('value', listener)
    }
  },
  futureJobs : {
    attach: (teamId, contactId, customerId, listener) => {
      const today = moment().format('YYYY-MM-DD')
      const endDate = '2020-12-30'
      const startKey = `${contactId}@${customerId}@${today}`
      const endKey = `${contactId}@${customerId}@${endDate}`
      firebase.database()
        .ref(`customer_events/${teamId}`)
        .orderByChild('customerContactId_endDate')
        .startAt(startKey)
        .endAt(endKey)
        .on('value', listener)
    },
    detach: (teamId, contactId, customerId, listener) => {
      const today = moment().format('YYYY-MM-DD')
      const startKey = `${contactId}@${customerId}@${today}`
      const endKey = `${contactId}@${customerId}@`
      firebase.database()
        .ref(`customer_events/${teamId}`)
        .orderByChild('customerContactId_endDate')
        .startAt(startKey)
        .endAt(endKey)
        .off('value', listener)
    }
  }
}

export default SummaryQueries



// WEBPACK FOOTER //
// ./src/customer/CustomerSummary/SummaryQueries.js